module.exports = __webpack_public_path__ + "img/addressUpdated.cd86408b.svg";